/**
 * Builds the per-table customer link that a QR code on the table encodes.
 *
 * A customer who opens `?id=<idServices>&key=<config.id>&idmesa=<n>` is routed
 * (App.svelte -> Login.svelte's muestra()) into the restaurant/table-service
 * flow for this exact service, landing on servicioMesa.svelte with table `n`
 * preselected. `config.id` must come from the `listRatinggs` entry whose
 * `config.mode === 1` ("Dinerserv", seeded for every restaurant-mode account
 * in Configuracion.svelte) - muestra() matches by config.id alone, so using
 * any other entry's id would route the customer into the wrong survey.
 */

export function getRestaurantConfig(listRatinggs) {
  if (!Array.isArray(listRatinggs)) {
    return null;
  }

  return listRatinggs.find((item) => item?.config?.mode === 1) || null;
}

export function buildMesaUrl(service, n) {
  if (!service || !service.idServices) {
    return null;
  }

  const restaurantConfig = getRestaurantConfig(service.listRatinggs);
  if (!restaurantConfig) {
    return null;
  }

  return `${window.location.origin}/?id=${service.idServices}&key=${restaurantConfig.config.id}&idmesa=${n}`;
}
